import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=392bf399&scoped=true&"
import script from "./ScoreBoard.vue?vue&type=script&lang=js&"
export * from "./ScoreBoard.vue?vue&type=script&lang=js&"
import style0 from "./ScoreBoard.vue?vue&type=style&index=0&id=392bf399&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bf399",
  null
  
)

export default component.exports